import ldIsNull from 'lodash/isNull';
import ldIsUndefined from 'lodash/isUndefined';
import { getCompanyCfcDisplayName, SimpleDictionary } from '../../../Common';
import { SearchCategoryState } from '../../../redux/reducers/SearchCategoryReducer';
import { SearchConditionState } from '../../../redux/reducers/SearchConditionReducer';

const DISPLAY_CONDITION_TITLES: SimpleDictionary = {
  keyword: 'フリーワード',
  createDate: '初回登録日',
  latestUpdateDate: '最終更新日',
  actionDate: 'アクション予定日',
};

export function getItemNames(searchCategory: SearchCategoryState, key: string, conditionsItems: (string | null)[]): string[] {
  const itemNames: string[] = [];
  const largeCategory = searchCategory.categories.find((large) =>
    large.middleCategory.find((middle) => middle.middleCategoryCdMapping === key)
  );
  const middleCategory = largeCategory?.middleCategory.find((middle) => middle.middleCategoryCdMapping === key);
  conditionsItems.forEach((item) => {
    const itemName = middleCategory?.smallCategory?.find((small) => small.smallCategoryCd === item)?.smallCategoryCdName;
    if (itemName) {
      itemNames.push(itemName);
    } else {
      itemNames.push(item ? item : '');
    }
  });
  return itemNames;
}

export function getConditionTitle(searchCategory: SearchCategoryState, key: string): string | undefined {
  if (DISPLAY_CONDITION_TITLES[key]) {
    return DISPLAY_CONDITION_TITLES[key];
  }
  const largeCategory = searchCategory.categories.find((large) =>
    large.middleCategory.find((middle) => middle.middleCategoryCdMapping === key)
  );
  return largeCategory?.middleCategory.find((middle) => middle.middleCategoryCdMapping === key)?.middleCategoryCdName;
}

export const getAgencyStoreShortName = (shortName: string | null | undefined, agencyCd: string, companyCfc: string): string => {
  if (ldIsNull(shortName) || ldIsUndefined(shortName)) {
    return agencyCd;
  }
  return getCompanyCfcDisplayName(companyCfc, shortName);
};

export const getSearchConditionNoEmpty = (searchCondition: SearchConditionState | undefined): SearchConditionState => {
  return searchCondition?.filter((item) => item?.specifiedCondition.length) || [];
};
